export type SubscriptionLike = {
  plan_id?: string;
  tier_type?: string;
  status?: string;
  is_free_trial_offer?: boolean;
  aws_account_count?: number | string;
  quantity?: number | string;
} | null | undefined;

export function isAwsMarketplaceSubscription(subscription: SubscriptionLike): boolean {
  return subscription?.plan_id === 'aws' || subscription?.tier_type === 'AWS';
}

export function isFreeTrialSubscription(subscription: SubscriptionLike): boolean {
  return getSubscriptionAccountLimits(subscription).isFreeTrial;
}

export function parseAccountLimit(value: number | string | undefined | null): number | null {
  if (value === undefined || value === null || value === '') {
    return null;
  }

  const parsed = typeof value === 'string' ? parseInt(value, 10) : value;
  if (Number.isNaN(parsed) || parsed < 0) {
    return null;
  }

  return parsed;
}

export function getSubscriptionAccountLimits(subscription: SubscriptionLike): {
  isFreeTrial: boolean;
  isExpired: boolean;
  maxAccounts: number | null;
} {
  if (!subscription) {
    return { isFreeTrial: true, isExpired: false, maxAccounts: null };
  }

  if (isAwsMarketplaceSubscription(subscription)) {
    const maxAccounts = parseAccountLimit(subscription.aws_account_count ?? subscription.quantity);
    return {
      isFreeTrial: subscription.is_free_trial_offer === true,
      isExpired: false,
      maxAccounts,
    };
  }

  const isActive = subscription.status === 'ACTIVE';
  const isFreeTrial = !isActive || subscription.plan_id === 'free';

  let maxAccounts: number | null = null;
  if (isActive && (subscription.plan_id === 'fixed' || subscription.tier_type === 'Fixed')) {
    maxAccounts = parseAccountLimit(subscription.aws_account_count ?? subscription.quantity);
  }

  return { isFreeTrial, isExpired: false, maxAccounts };
}

export function getMaxAccountsFromSubscription(subscription: SubscriptionLike): number | null {
  if (!subscription) {
    return null;
  }

  if (isAwsMarketplaceSubscription(subscription)) {
    return parseAccountLimit(subscription.aws_account_count ?? subscription.quantity);
  }

  if (subscription.status !== 'ACTIVE') {
    return null;
  }

  if (subscription.plan_id === 'fixed' || subscription.tier_type === 'Fixed') {
    return parseAccountLimit(subscription.aws_account_count ?? subscription.quantity);
  }

  return null;
}
